<template>
  <v-dialog
      v-model="dialog"
      persistent
      fullscreen
      max-width="290"
  >
    <v-card height="80%">
      <v-card-text class="pa-0 text-center" style="padding-top: 35% !important;">
        <v-timeline
            dense
            clipped
        >
          <v-timeline-item
              fill-dot
              class="mb-3"
              color="orange"
              large
          >
            <template v-slot:icon>
              <v-progress-circular
                  indeterminate
                  size="40"
                  width="4"
                  color="white"
              ></v-progress-circular>
            </template>
            <p class="text-h6">Por favor, aguarde enquanto registramos seu pedido</p>
          </v-timeline-item>

            <v-timeline-item
                v-for="(event, index) in stepsRequest"
                :key="index"
                class="mb-4"
                :color="event.success ? 'primary' : 'gray'"
                small
            >
              <v-row>
                <v-col
                    cols="12"
                    class="text-left"
                    :class="{'font-weight-bold': event.success}"
                >
                  {{event.text}}
                  <v-progress-circular
                      v-if="event.processing"
                      indeterminate
                      size="15"
                      width="2"
                      color="primary"
                ></v-progress-circular>
                </v-col>
              </v-row>
            </v-timeline-item>
        </v-timeline>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "DialogSendingRequest",
  props: {
    dialog: {
      required: true
    },
    stepsRequest: {
      required: true,
      type: Array
    }
  }
}
</script>

<style scoped>

</style>